import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/Bustan-Al-Sukkar--Logo-Final-web-022.png'
import Contactus from "../../images/options.jpg"
import Newslatter from '../../components/Newslatter/Newslatter';
import ContactpageSec from '../../components/ContactpageSec/ContactpageSec';


const ContactPage =() => {
    return(
        <Fragment>
            <Navbar hclass={'wpo-header-style-3'} Logo={Logo} />
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} Image={Contactus} /> 
            <ContactpageSec/> 
            <Newslatter nClass={'section-bg'}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default ContactPage;

